export function impressionAnalytics(data) {
  return new Promise((resolve, reject) => {
    resolve(
      window.LIFE_CYCLE_EVENT_BUS.trigger('impression.trigger', data)
    );
  });
}
